import { render, staticRenderFns } from "./FieldCustomhtml.vue?vue&type=template&id=13b04f40&"
import script from "./FieldCustomhtml.vue?vue&type=script&lang=js&"
export * from "./FieldCustomhtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports